export const PRODUCT_FOUND = 'PRODUCT_FOUND'
